var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-sheet',{staticClass:"d-flex justify-center align-center flex-grow-0 flex-shrink-0",class:_vm.color,attrs:{"rounded":_vm.rounded,"height":_vm.size,"width":_vm.size}},[_c('v-icon',{attrs:{"color":"ui-kit-bg-gray-0","size":_vm.iconSize}},[_vm._v("\n    "+_vm._s(_vm.icon)+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }